import { IconProps } from '.';

const MapIcon = ({ color, customClasses, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 40 40"
      fill="none"
      className={customClasses}
      {...rest}
    >
      <g clipPath="url(#clip0_18177_142914)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15 3.60254L25.0217 8.61337L35.3095 3.86513C35.6966 3.6865 36.148 3.71742 36.507 3.94716C36.8661 4.17691 37.0833 4.5738 37.0833 5.00008V30.0001C37.0833 30.4876 36.7998 30.9307 36.3572 31.135L24.9783 36.3868L15 31.3976L5.55902 36.1181C5.17153 36.3119 4.71136 36.2912 4.34284 36.0634C3.97432 35.8356 3.75 35.4333 3.75 35.0001V10.0001C3.75 9.52662 4.0175 9.09379 4.44098 8.88205L15 3.60254ZM34.5833 6.95372L24.9783 11.3868L15 6.39762L6.25 10.7726V32.9775L15 28.6025L25.0217 33.6134L34.5833 29.2003V6.95372Z"
          fill={color || 'var(--color-ui-icon-primary)'}
        />
      </g>
      <defs>
        <clipPath id="clip0_18177_142914">
          <rect
            width="40"
            height="40"
            fill={color || 'var(--color-ui-icon-primary)'}
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default MapIcon;
